module.exports = __webpack_public_path__ + "static/media/FREERIDER-RF-5600-iQ.8c1d85ee.png";